import {FilterType, IGameFilter} from './game-filter.interface';
import {GameInfo} from '../../games/game-info';
import {ActiveFilter} from '../games-filter.service.interface';
import {GameGroupFilter} from "./game-group.filter";
import {SubgroupNameFilter} from "./subgroup-name.filter";

export class AllBaccaratFilter implements IGameFilter {

    get filterType(): FilterType {
        return FilterType.categoryFilter
    }

    applyFilter(gameInfo: GameInfo, currentActiveFilters: ActiveFilter[]): boolean {
        return new GameGroupFilter('Baccarat').applyFilter(gameInfo, currentActiveFilters)
            || new SubgroupNameFilter('baccarat').applyFilter(gameInfo, currentActiveFilters)
    }
}